import { useEffect, useState } from "react";
import api from "@/lib/api";
import { ImageOff } from "lucide-react";

// Exibe imagem protegida (fetch com Bearer -> blob)
export default function AuthImage({ path, className, alt = "foto" }) {
  const [src, setSrc] = useState(null);
  const [err, setErr] = useState(false);

  useEffect(() => {
    let url;
    let active = true;
    api.get(`/files/${path}`, { responseType: "blob" })
      .then((r) => { if (active) { url = URL.createObjectURL(r.data); setSrc(url); } })
      .catch(() => active && setErr(true));
    return () => { active = false; if (url) URL.revokeObjectURL(url); };
  }, [path]);

  if (err) return <div className={`flex items-center justify-center bg-secondary text-muted-foreground ${className}`}><ImageOff className="w-5 h-5" /></div>;
  if (!src) return <div className={`animate-pulse bg-secondary ${className}`} />;
  return <img src={src} alt={alt} className={className} />;
}
